import Popover from "@stimulus-components/popover"

export default class extends Popover {
  connect() {
    super.connect()
    this._hideTimeout = null
    this._boundDocumentHandler = this._handleDocumentMouseMove.bind(this)
  }

  show(event) {
    clearTimeout(this._hideTimeout)
    super.show(event)
    setTimeout(() => this._addPopoverListeners(), 10)
    document.addEventListener('mousemove', this._boundDocumentHandler)
  }

  hide(event) {
    this._hideTimeout = setTimeout(() => {
      super.hide(event)
      document.removeEventListener('mousemove', this._boundDocumentHandler)
    }, 120)
  }

  _addPopoverListeners() {
    const popover = document.querySelector('[data-popover-target="card"]')
    if (popover && !popover._listenersAdded) {
      popover.addEventListener('mouseenter', () => clearTimeout(this._hideTimeout))
      popover.addEventListener('mouseleave', (e) => this.hide(e))
      popover._listenersAdded = true
    }
  }

  _handleDocumentMouseMove(e) {
    const trigger = this.element
    const popover = document.querySelector('[data-popover-target="card"]')
    if (!trigger || !popover) return

    const overTrigger = trigger.contains(e.target)
    const overPopover = popover.contains(e.target)
    if (!overTrigger && !overPopover) {
      this.hide()
    }
  }
}
